import { useCallback, useEffect, useRef } from 'react';
import { clearSubmitting, handleValidForm } from 'nike-form-js';

export function useFormSubmit(form, onSubmit, throttlingDelay = 1200) {
    const timer = useRef();
    useEffect(() => () => clearTimeout(timer.current), []);
    return useCallback(
        function submitForm(e) {
            e.preventDefault();

            handleValidForm(form, formValues => {
                clearTimeout(timer.current);
                onSubmit(formValues, form);
                timer.current = setTimeout(() => clearSubmitting(form), throttlingDelay);
            })(e);
        },
        [form, throttlingDelay, onSubmit]
    );
}
